import { useCallback, useState } from 'react';

import copyToClipboard from '@/shared/lib/copyToClipboard';
import { emailValidator } from '@/shared/lib/format/validators';
import { useSendShareEmail } from './useSendShareEmail';

const useShareButton = (
  code?: string,
  shareUrlOverride?: string,
  extraPayload?: Record<string, string>
) => {
  const [modalOpen, setModalOpenInternal] = useState<boolean>(false);
  const [content, setContent] = useState<string>('');
  const [recipient, setRecipient] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');
  const { mutate: sendShareEmail } = useSendShareEmail();

  const setModalOpen = useCallback((value: boolean) => {
    setContent('');
    setEmailError('');
    setRecipient('');
    setModalOpenInternal(value);
  }, []);

  let shareUrl: string;
  if (shareUrlOverride) {
    shareUrl = shareUrlOverride;
  } else {
    const { protocol, host } = window.location;
    shareUrl = code ? `${protocol}//${host}/${code}` : window.location.href;
  }

  const sendEmail = () => {
    const errorMessage = emailValidator(recipient);
    if (errorMessage) {
      setEmailError(errorMessage);
      return false;
    }
    setModalOpen(false);
    sendShareEmail({ content, recipient, url: shareUrl, extraPayload });
    return true;
  };

  const handleCopyToClipboard = async () => {
    await copyToClipboard(shareUrl, 'Link copied to clipboard!');
  };

  const handleChangeRecipient = (value: string) => {
    setEmailError('');
    setRecipient(value);
  };

  return {
    modalOpen,
    setModalOpen,
    content,
    setContent,
    recipient,
    handleChangeRecipient,
    handleCopyToClipboard,
    sendEmail,
    emailError,
    shareUrl
  };
};

export default useShareButton;
